export default "__VITE_ASSET__CVSyax26__"